import { gql } from '@apollo/client'
import { useMediaQuery } from '@material-ui/core'
import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Accordion } from '../../../components/accordion/accordion'
import { html } from '../../../utils/htmlParser'
import { nonNull } from '../../../utils/nonNull'
import { PopularQuestionsFragment } from './__generated__/popularQuestions'

export const StyledAccordionPanel = styled(Accordion)`
  background: #fff;
  border-radius: 5px;
  padding: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    margin-right: 0;
  }

  &.Mui-expanded {
    margin-right: 0;
  }
`
export const StyledAccordionTitle = styled(Accordion)`
  color: ${props => props.theme.palette.text.secondary};
  font-size: ${props => props.theme.typography.pxToRem(16)};

  .Mui-expanded {
    color: ${props => props.theme.palette.text.primary};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(22)};
  }

`
export const StyledAccordionContent = styled(Accordion)`
  color: ${props => props.theme.palette.text.secondary};
  font-size: ${props => props.theme.typography.pxToRem(14)};
  line-height: 1.8;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
  }
`
export const StyledAccordionColumn = styled(Accordion)`
  padding-right: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    padding: 0 ${props => props.theme.typography.pxToRem(10)};
  }
`

export type PopularQuestionsProps = {
  data?: PopularQuestionsFragment[]
}

export const PopularQuestions: React.VFC<PopularQuestionsProps> = ({ data }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  if (!data?.[0]) {
    return null
  }

  const { leftColumnFaqs, rightColumnFaqs } = data[0]

  return (
    <Accordion spacing={isMobile ? 0 : 2}>
      {leftColumnFaqs && (
        <StyledAccordionColumn column>
          {nonNull(leftColumnFaqs).map((faq, _) => {return faq.__typename !== 'faqs_default_Entry' ? null :(
            <StyledAccordionPanel panel key={faq.id} tabIndex={0}>
              <StyledAccordionTitle title>{faq.title}</StyledAccordionTitle>
              {faq.faqText && (
                <StyledAccordionContent content>{html(faq.faqText)}</StyledAccordionContent>
              )}
            </StyledAccordionPanel>
          )})}
        </StyledAccordionColumn>
      )}

      {rightColumnFaqs && (
        <StyledAccordionColumn column>
          {nonNull(rightColumnFaqs).map((faq, _) => {return faq.__typename !== 'faqs_default_Entry' ? null :(
            <StyledAccordionPanel panel key={faq.id} tabIndex={0}>
              <StyledAccordionTitle title>{faq.title}</StyledAccordionTitle>
              {faq.faqText && (
                <StyledAccordionContent content>{html(faq.faqText)}</StyledAccordionContent>
              )}
            </StyledAccordionPanel>
          )})}
        </StyledAccordionColumn>
      )}
    </Accordion>
  )
}

export const POPULAR_QUESTIONS_FRAGMENT = gql`
  fragment PopularQuestionsFragment on popularQuestions_BlockType {
    leftColumnFaqs {
      ... on faqs_default_Entry {
        id
        title
        faqText
      }
    }
    rightColumnFaqs {
      ... on faqs_default_Entry {
        id
        title
        faqText
      }
    }
  }
`